import { iframeService } from '@pascal/pascal-core';
import { toasterService } from '../toaster/toasterService';
import { ERROR_TYPES } from '../../core/enums/ERROR_TYPES';

class ErrorHandler {
  constructor() {
    this._registeredHandlers = {};
  }

  handle(error) {
    if (this._registeredHandlers[error?.errorMessage]) {
      return this._registeredHandlers[error?.errorMessage](error);
    } else {
      toasterService.handleErrorMessageWIthMessageCode(error?.errorMessage);
      console.error(error);
    }
  }

  register(errorType, handler) {
    this._registeredHandlers[ERROR_TYPES[errorType]] = handler;
    return this;
  }

  notEnoughMoney() {
  }
}

const errorHandler = new ErrorHandler(ERROR_TYPES);

errorHandler
  .register(ERROR_TYPES.INVALID_AMOUNT, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.INVALID_AMOUNT);
  })
  .register(ERROR_TYPES.INVALID_SPIN, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.INVALID_SPIN);
  })
  .register(ERROR_TYPES.NOT_ENOUGH_MONEY, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.NOT_ENOUGH_MONEY);
  })
  .register(ERROR_TYPES.MONEY_TRANSACTION_ERROR, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.MONEY_TRANSACTION_ERROR);
  })
  .register(ERROR_TYPES.SPIN_NOTFOUND, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.SPIN_NOTFOUND);
  })
  .register(ERROR_TYPES.INVALID_SPIN_COUNT, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.INVALID_SPIN_COUNT);
  })
  .register(ERROR_TYPES.INVALID_OPERATION, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.INVALID_OPERATION);
  })
  .register(ERROR_TYPES.PlayerLimitExceeded, () => {
    toasterService.handleErrorMessageWIthMessageCode(ERROR_TYPES.PlayerLimitExceeded);
  })
  .register(ERROR_TYPES.INVALID_TOKEN, () => {
    if (iframeService.isInIframe()) {
      iframeService.reloadFrame();
    } else {
      window.location.reload();
    }
  });


export {
  errorHandler,
};
